// extracted by mini-css-extract-plugin
export default {"anchor":"product_detail_nav__anchor--YTHU","navContainer":"product_detail_nav__navContainer--WNPm","contentWrapper":"product_detail_nav__contentWrapper--9flL"};